module.exports = __webpack_public_path__ + "img/product_2.4c44b93f.png";